<div class="container">
  <div class="step-wrapper" *ngFor="let step of steps.steps" [class.done]="done(step)" [class.current]="current(step)">
    {{ step }}
  </div>
</div>
